exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "html[dir] ._3pp1Qufz2t7toh0C6btOdR{margin-bottom:20px}._1ebMuzYXLa7vqjY032dKYy{color:\"[theme:themePrimary, default:#0078D7]\"}html[dir] ._1ebMuzYXLa7vqjY032dKYy{margin-bottom:20px}html[dir] ._2gZbSwWPWALYmXEDAFAR7I{margin-top:-8px}html[dir] ._3YlXHVRQMm7SdIXKfZfzRA{margin-bottom:10px}", ""]);

// exports
exports.locals = {
	"renameFolders": "_3pp1Qufz2t7toh0C6btOdR",
	"reloadButton": "_1ebMuzYXLa7vqjY032dKYy",
	"quickSettingWrapper": "_2gZbSwWPWALYmXEDAFAR7I",
	"quickSettingOption": "_3YlXHVRQMm7SdIXKfZfzRA"
};